import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { IMenuItem, MenuItem, MenuItemHref, Popover } from '@gik/ui';

const blockName = 'menu';

export interface IMenuProps {
  items: IMenuItem[];
  isOpen: boolean;
  onClose: () => void;
  onHover: () => void;
  trigger: React.ReactElement;
  className?: string;
}

export default function Menu({ items, className, isOpen, onClose, trigger, onHover }: IMenuProps) {
  const bem = bemBlock(blockName);

  return (
    <>
      <Popover
        className={bem(null, null, className)}
        trigger={trigger}
        isOpen={isOpen}
        onClose={onClose}
        onHover={onHover}
        hasArrowIndicator={false}
        overlap
        hoverable
        noPad
      >
        {items.map((item, key) => (
          <MenuItem className={bem('item')} key={key} item={item} />
        ))}
      </Popover>

      <ul className={bem('seo-navbar')}>
        {items.map((item, key) => (
          <li key={key}>
            <a href={(item as MenuItemHref).href || '#'}>{item.label}</a>
          </li>
        ))}
      </ul>
    </>
  );
}
